import { Pipe, PipeTransform, Inject } from '@angular/core';
import { FORMATS_CONFIGURATION_TOKEN, FormatConfiguration } from '../tokens';

@Pipe({
  name: 'country'
})
export class CountryPipe implements PipeTransform {
  constructor(
    @Inject(FORMATS_CONFIGURATION_TOKEN)
    private configuration: FormatConfiguration
  ) {}

  transform(value: any): string {
    return !value
      ? `-`
      : this.configuration.countries.find(country => country.code === value)
          .name;
  }
}
